import { render, staticRenderFns } from "./InfocardsTable.vue?vue&type=template&id=12f75f56&scoped=true&"
import script from "./InfocardsTable.vue?vue&type=script&lang=js&"
export * from "./InfocardsTable.vue?vue&type=script&lang=js&"
import style0 from "./InfocardsTable.vue?vue&type=style&index=0&id=12f75f56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f75f56",
  null
  
)

export default component.exports